import React from 'react';

const Item_details_block_name = ({ name }) => (
    <div className="item_details_block_name bold">{name}</div>
);

export default Item_details_block_name;
